import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ArticleCollection from "../components/article-collection"
import { useMetaCollectionGroups } from "../meta/collection/groups"

const GroupsPage = () => {
  const description = useMetaCollectionGroups().plain

  return (
    <Layout>
      <SEO title="Groups" description={description} />

      <StaticQuery
        query={graphql`
          query Groups {
            groups: allMarkdownRemark(
              filter: { fields: { contentKind: { eq: "group" } } }
              sort: { fields: frontmatter___title, order: ASC }
            ) {
              ...ArticleCollectionFragment
            }
          }
        `}
        render={data => (
          <ArticleCollection articleTypePath="/groups" articles={data.groups} />
        )}
      />
    </Layout>
  )
}

export default GroupsPage
